import { allMovies, featuredIds } from '@/mocks/movies';
import MovieCard from '@/components/feature/MovieCard';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function FeaturedSection() {
  const featured = featuredIds
    .map((id) => allMovies.find((movie) => movie.id === id))
    .filter((movie): movie is (typeof allMovies)[number] => Boolean(movie));

  return (
    <section id="featured" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-8">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="今日精选"
            title="今天值得点开的那几部"
            subtitle="编辑每天从片库里挑出 6 部不同气质的好片。喜欢紧张刺激还是安静治愈，先从这里对号入座。"
          />
          <a
            href="#genres"
            className="inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 font-label text-sm font-medium text-foreground-700 transition-colors duration-200 hover:border-primary-400 hover:text-primary-600"
          >
            去完整片库
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </a>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-5 lg:grid-cols-6">
          {featured.map((movie) => (
            <MovieCard key={movie.id} movie={movie} compact />
          ))}
        </div>
      </div>
    </section>
  );
}